export default __webpack_public_path__ + "static/media/e-commerce.56bcc7e7.png";